import React from "react";

import DynamicForm from "../../../../../content-components/DynamicForm";
import { StyledType, Container } from "./index.styled";

const ClinicalGuidance = ({ title, componentsList }) => {
  return (
    <Container data-auto="clinical-guidance-section">
      {title ? (
        <DynamicForm componentsList={[title]} />
      ) : (
        <StyledType element="h2" color="senary" fontFamily="secondary">
          Clinical Guidance
        </StyledType>
      )}
      <DynamicForm componentsList={componentsList} />
    </Container>
  );
};

export default ClinicalGuidance;
